const ORDER_ID_KEY = 'association_order_id'

export const getOrderId = (): number | null => {
  try {
    const orderId = localStorage.getItem(ORDER_ID_KEY)
    return orderId ? parseInt(orderId, 10) : null
  } catch (error) {
    console.error('Error reading order ID from localStorage:', error)
    return null
  }
}

export const setOrderId = (orderId: number): void => {
  try {
    localStorage.setItem(ORDER_ID_KEY, orderId.toString())
  } catch (error) {
    console.error('Error saving order ID to localStorage:', error)
  }
}

export const clearOrderId = (): void => {
  try {
    localStorage.removeItem(ORDER_ID_KEY)
  } catch (error) {
    console.error('Error clearing order ID from localStorage:', error)
  }
}

/**
 * Mesmo critério do backend (updateOrderCart / getLastOrderOpenByUser):
 * o pedido está fechado se QUALQUER pagamento tiver status 'paid'.
 */
export const isOrderPaid = (order?: { payments?: Array<{ status?: string }> | null } | null): boolean =>
  !!order?.payments?.some((payment) => payment?.status === 'paid')

/** Origem atribuída pelo backend ao order_cart criado com association_site */
export const ASSOCIATION_ORDER_ORIGIN = 'site-aspaec'

type StoredOrderLike = {
  originCheckout?: string | null
  payments?: Array<{ status?: string }> | null
} | null

/**
 * O id salvo só representa o carrinho do associado se o pedido for da origem
 * site-aspaec e ainda não estiver pago.
 */
export const isOpenAssociationOrder = (order?: StoredOrderLike): boolean =>
  !!order && order.originCheckout === ASSOCIATION_ORDER_ORIGIN && !isOrderPaid(order)
